import React from "react";
import { Container } from "react-bootstrap";
import { MatchingTool } from "./index";

const Tool = () => {
  return (
    <Container fluid className="p-0 m-0 mb-3">
      <MatchingTool />
    </Container>
  );
};

export default Tool;
